/* eslint-disable global-require */
import React, { Component } from 'react';
import {
  Button, Dropdown, Icon, Layout, Menu, message, Popover, Select
} from 'antd';
import { connect } from 'react-redux';
import CustomScrollbars from 'util/CustomScrollbars';
import PropTypes from 'prop-types';
import SearchBox from 'components/SearchBox';
import UserInfo from 'components/UserInfo';
import AppNotification from 'components/AppNotification';
import MailNotification from 'components/MailNotification';
import { Link } from 'react-router-dom';
import languageData from '../languageData';
import HorizontalNav from '../HorizontalNav';
import { switchLanguage, toggleCollapsedSideNav } from '../../../appRedux/actions/Setting';
import IntlMessages from '../../../util/IntlMessages';

const { Header } = Layout;

const { Option } = Select;

function handleMenuClick(e) {
  message.info('Click on menu item.');
}

const menu = (
  <Menu onClick={handleMenuClick}>
    <Menu.Item key="1">Products</Menu.Item>
    <Menu.Item key="2">Apps</Menu.Item>
    <Menu.Item key="3">Blogs</Menu.Item>
  </Menu>
);

function handleChange(value) { }

class HorizontalDark extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: ''
    };
  }

  languageMenu = () => (
    <CustomScrollbars className="gx-popover-lang-scroll">
      <ul className="gx-sub-popover">
        {languageData.map((language) => (
          // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
          <li
            key={JSON.stringify(language)}
            className="gx-media gx-pointer"
            onClick={(e) => this.props.switchLanguage(language)}
          >
            <i className={`flag flag-24 gx-mr-2 flag-${language.icon}`} />
            <span className="gx-language-text">{language.name}</span>
          </li>
        ))}
      </ul>
    </CustomScrollbars>
  );

  updateSearchChatUser = (evt) => {
    this.setState({
      searchText: evt.target.value
    });
  };

  render() {
    const { locale, navCollapsed } = this.props;

    return (
      <div className="gx-header-horizontal gx-header-horizontal-dark">
        <div className="gx-header-horizontal-top">
          <div className="gx-container">
            <div className="gx-header-horizontal-top-flex">
              <div className="gx-header-horizontal-top-left">
                <i className="icon icon-alert gx-mr-3" />
                <p className="gx-mb-0 gx-text-truncate">
                  <IntlMessages id="app.announced" />
                </p>
              </div>
              <ul className="gx-login-list">
                <li>Login</li>
                <li>Signup</li>
              </ul>
            </div>
          </div>
        </div>

        <Header className="gx-header-horizontal-main">
          <div className="gx-container">
            <div className="gx-header-horizontal-main-flex">
              <div className="gx-d-block gx-d-lg-none gx-linebar gx-mr-xs-3">
                <i
                  className="gx-icon-btn icon icon-menu"
                  onClick={() => {
                    this.props.toggleCollapsedSideNav(!navCollapsed);
                  }}
                />
              </div>
              <Link className="gx-d-block gx-d-lg-none gx-pointer gx-mr-xs-3 gx-pt-xs-1 gx-w-logo" to="/">
                <img alt="" src={require('assets/images/w-logo.png')} />
              </Link>
              <Link className="gx-d-none gx-d-lg-block gx-pointer gx-mr-xs-5 gx-logo" to="/">
                <img alt="" src={require('assets/images/logo.png')} />
              </Link>
              <div className="gx-header-search gx-d-none gx-d-lg-flex">
                <SearchBox
                  onChange={this.updateSearchChatUser}
                  placeholder="Search in app..."
                  styleName="gx-lt-icon-search-bar-lg"
                  value={this.state.searchText}
                />

                <Select defaultValue="lucy" onChange={handleChange} style={{ width: 120 }}>
                  <Option value="jack">Products</Option>
                  <Option value="lucy">Apps</Option>
                  <Option value="Yiminghe">Blogs</Option>
                </Select>
              </div>

              <ul className="gx-header-notifications gx-ml-auto">
                <li className="gx-notify gx-notify-search gx-d-inline-block gx-d-lg-none">
                  <Popover
                    content={(
                      <div className="gx-d-flex">
                        <Dropdown overlay={menu}>
                          <Button>
                            Category <Icon type="down" />
                          </Button>
                        </Dropdown>
                        <SearchBox
                          onChange={this.updateSearchChatUser}
                          placeholder="Search in app..."
                          styleName="gx-popover-search-bar"
                          value={this.state.searchText}
                        />
                      </div>
                    )}
                    overlayClassName="gx-popover-horizantal"
                    placement="bottomRight"
                    trigger="click"
                  >
                    <span className="gx-pointer gx-d-block">
                      <i className="icon icon-search-new" />
                    </span>
                  </Popover>
                </li>

                <li className="gx-notify">
                  <Popover
                    content={<AppNotification />}
                    overlayClassName="gx-popover-horizantal"
                    placement="bottomRight"
                    trigger="click"
                  >
                    <span className="gx-pointer gx-d-block">
                      <i className="icon icon-notification" />
                    </span>
                  </Popover>
                </li>

                <li className="gx-msg">
                  <Popover
                    content={<MailNotification />}
                    overlayClassName="gx-popover-horizantal"
                    placement="bottomRight"
                    trigger="click"
                  >
                    <span className="gx-pointer gx-status-pos gx-d-block">
                      <i className="icon icon-chat-new" />
                      <span className="gx-status gx-status-rtl gx-small gx-orange" />
                    </span>
                  </Popover>
                </li>
                <li className="gx-language">
                  <Popover
                    content={this.languageMenu()}
                    overlayClassName="gx-popover-horizantal"
                    placement="bottomRight"
                    trigger="click"
                  >
                    <span className="gx-pointer gx-flex-row gx-align-items-center">
                      <i className={`flag flag-24 flag-${locale.icon}`} />
                    </span>
                  </Popover>
                </li>
                <li className="gx-user-nav">
                  <UserInfo />
                </li>
              </ul>
            </div>
          </div>
        </Header>
        <div className="gx-header-horizontal-nav gx-d-none gx-d-lg-block">
          <div className="gx-container">
            <div className="gx-header-horizontal-nav-flex">
              <HorizontalNav />
              <ul className="gx-header-notifications gx-ml-auto">
                <li>
                  <span className="gx-pointer gx-d-block">
                    <i className="icon icon-menu-lines" />
                  </span>
                </li>
                <li>
                  <span className="gx-pointer gx-d-block">
                    <i className="icon icon-setting" />
                  </span>
                </li>
                <li>
                  <span className="gx-pointer gx-d-block">
                    <i className="icon icon-apps-new" />
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

HorizontalDark.propTypes = {
  switchLanguage: PropTypes.func,
  locale: PropTypes.objectOf(PropTypes.any).isRequired,
  navCollapsed: PropTypes.bool,
  toggleCollapsedSideNav: PropTypes.func
};

HorizontalDark.defaultProps = {
  switchLanguage: () => { },
  toggleCollapsedSideNav: () => { },
  navCollapsed: false
};

const mapStateToProps = ({ settings }) => {
  const { locale, navCollapsed } = settings;
  return { locale, navCollapsed };
};
export default connect(mapStateToProps, { toggleCollapsedSideNav, switchLanguage })(HorizontalDark);
